export default [{
  label: 'Male',
  value: 'M',
}, {
  label: 'Female',
  value: 'F',
}]



// WEBPACK FOOTER //
// ./src/constants/sex.js